import { MainColor } from '../../palette/colors';

export const getOrderDetailsTheme = () => {
  return {
    details: {
      brigadeAndWork: {
        leaderSection: {
          bgColor: 'coolGrey5' as MainColor,
          borderColor: 'coolGrey10' as MainColor,
        },
      },
    },
    edit: {
      brigadeAndWork: {
        selectedWorkers: {
          backgroundColor: 'coolGrey5' as MainColor,
        },
      },
    },
    sideColumn: {
      footer: {
        belowBudget: 'green50' as MainColor,
        aboveBudget: 'red50' as MainColor,
      },
    },
  };
};

export type OrderDetailsTheme = ReturnType<typeof getOrderDetailsTheme>;
